export default __webpack_public_path__ + "static/media/fo.524e4ea2.jpg";